import { useEffect } from 'react';
import ChangeHistoryView from './ChangeHistoryView';

export default function ChangeHistoryModal({ onClose, onNavigateToContact }) {
  // ESC closes
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white dark:bg-slate-900 rounded-xl shadow-2xl w-full max-w-4xl max-h-[85vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-slate-700">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Historial de Cambios</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full hover:bg-gray-100 dark:hover:bg-slate-700 text-gray-500 dark:text-gray-400 flex items-center justify-center text-lg"
            title="Cerrar (Esc)"
          >&#x2715;</button>
        </div>
        <div className="flex-1 overflow-y-auto">
          <ChangeHistoryView onNavigateToContact={onNavigateToContact} />
        </div>
      </div>
    </div>
  );
}
